export const licenseSliceName = 'license';
